import {
  Box,
  Button,
  Checkbox,
  Fade,
  MenuItem,
  Paper,
  Popper,
  PopperPlacementType,
  Select,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  IconButton,
} from "@mui/material";
import DangerousRoundedIcon from '@mui/icons-material/DangerousRounded';
// import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { DetailTrans } from "../prc/TzaDetailDialog";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { SearchBackDrop } from "../../component/common/SearchBackDrop";
import CustomPagination from "../../component/common/CustomPagination";
import EvalJsonDialog from "../EvalJsonDialog";


const initailEvknData: any = {
  idx : -1,

  task: "simpleqa",
  data_sources: "",
  category: "",
  subcategory: "",
  bmk_pk: "",
  difficulty: "",
  keyword: "",
  title: "",
  text: "",
  
  qa_type: "",
  answer_type: "",
  science_fact: "",
  common_knowledge: "",
  
  activity: "",
  question_a: "",
  question_b: "",
  question: "",

  answer: "",
  answer_index: "",

  option_1: "",
  option_2: "",
  option_3: "",
  option_4: "",
  option_5: "",

  reason_1: "",
  reason_2: "",
  reason_3: "",
  reason_4: "",
  reason_5: "",

  job_user:"",
  job_date:"",
  des:"",
};

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const EvknHellaSwagPage = (props: any) => {

  const [pageType, setPageType] = useState("new")

  const [openJsonDialog, setOpenJsonDialog] = useState<boolean>(false)

  const [search_doc_id, setSearch_doc_id] = useState("")

  const [evkn_detail_data, setEvkn_detail_data] = useState<any>(initailEvknData);

  const [page, setPage] = useState(1);
  const [c_page, setC_page] = useState("")
  const [order, setOrder] = useState('desc');
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const [pagination, setPagination] = useState<pageInfoType | undefined>(undefined);

  const [evknWorkList, setEvknWorkList] = useState([]);

  const [idx, setIdx] = useState('');
  const [job_yn, setJob_yn] = useState('모두');
  const [gub_cd, setGub_cd] = useState('모두');


  const [backdrop, setBackdrop] = useState<boolean>(false)

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  const createPrcEvknData = async () => {

    setBackdrop(true)
    if(evkn_detail_data.category == "None" || evkn_detail_data.category == ""){
      alert('주제분류 를 선택하세요.')
      return;
    }

    if(evkn_detail_data.answer == "None" || evkn_detail_data.answer == ""){
      alert('Answer - 입력하세요.')
      return;
    }

    // Task 마다 처리 해야함
    if((evkn_detail_data.question == "None" || evkn_detail_data.question == "") || (evkn_detail_data.question == "None" || evkn_detail_data.question == "")){
      alert('Question - 입력하세요.')
      return;
    }

    const formData = new FormData();

    formData.append("email", email);

    formData.append("worker", worker);

    formData.append("prc_data", JSON.stringify(evkn_detail_data));

    // console.log('json', JSON.stringify(evkn_detail_data))

    // return;

    await api.post("/prc-evkn-insert",formData)
    .then((res:any) => {alert("가공데이터 입력 완료"); setPageType("update"); setBackdrop(false);})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})

  }

  function normalizeReasonPathToString(input: any): string {
    if (!input) return "[]";
    if (Array.isArray(input)) return JSON.stringify(input);
    try {
      // 이미 문자열이면 유효성 확인 후 그대로 사용 (배열 JSON인지 확인)
      const parsed = JSON.parse(input);
      return Array.isArray(parsed) ? JSON.stringify(parsed) : "[]";
    } catch {
      // 잘못된 문자열이면 빈 배열
      return "[]";
    }
  }

  // 2) colEvknData 업데이트 (불변성 유지)
  

  const updateColEvknData = async (gub: any) => {

    setBackdrop(true)
    
    const formData = new FormData();

    formData.append("email", email);

    formData.append("worker", worker);

    formData.append("gub", gub);

    const updatedColEvknData = {
      ...colEvknData,
      reason_path: Array.isArray(reason_path) ? reason_path : (() => {
        try { return JSON.parse(reason_path as string); } catch { return []; }
      })(),
      options: Array.isArray(options) ? options : (() => {
        try { return JSON.parse(options as string); } catch { return []; }
      })(),
    };

    // console.log('바꾼거',JSON.stringify(updatedColEvknData))
    // return;
    
    formData.append("colEvknData", JSON.stringify(updatedColEvknData));

    await api.post("/updateColEvknData",formData)
    .then((res:any) => {alert(updatedColEvknData.document_id + " 데이터 검수 완료"); setPageType("update"); setBackdrop(false); getEvknWorkList();})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})

  }

  const [colEvknData, setColEvknData] = useState<any>([]);

  const [reason_path, setReason_path] = useState<any>([]);

  const reason_path_change = (idx: number, val: string) => {
    setReason_path((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  const [options, setOptions] = useState<any>([]);

  const options_change = (idx: number, val: string) => {
    setOptions((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  const handleAdd = () => setReason_path((prev) => [...prev, ""]);
  const handleRemove = (idx: number) =>
    setReason_path((prev) => prev.filter((_, i) => i !== idx));

  const search_data = useCallback(async () => {
      api.get('/getColEvknData', {params:{email:email,idx:search_doc_id}})
      .then((res:any) => {console.log("EVKN 데이터 조회 ", res.data.datas[0]); setColEvknData(res.data.datas[0]); setReason_path(JSON.parse(res.data.datas[0].reason_path)); if(res.data.datas[0].gub_cd !== '1') setOptions(JSON.parse(res.data.datas[0].options)); })
        // alert("파일 업로드가 완료되었습니다.");
      .catch((error:any) => {console.error('에러',error.response);})
      // alert("파일 업로드 실패. " + error.response.data.error);
    },[search_doc_id])

  const updateKeep = async () => {

    const formData = new FormData();

    formData.append("email", email);

    formData.append("document_id", search_doc_id);

    // console.log('evkn_detail_data', evkn_detail_data)

    // return ;
    
    await api.post("/updateColEvknData-keep",formData)
    .then((res:any) => { alert("데이터가 선정되었습니다."); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  const getEvknWorkList = async () => {
    
    // email != 'hafrica@hufs.ac.kr'
    let v_gub_cd = "3"

    if(worker === 'EVAL008')
      v_gub_cd = gub_cd

    setBackdrop(true)
    api.get('/evknWorkList',{params:{email:email, worker:worker, page:page, order:order, job_yn:job_yn, gub_cd:v_gub_cd, idx:idx}})
    .then((res:any) => {
      
      // console.log('리턴 데이터', res.data)
      if(res.data.datas.length > 0){
        // setInstructionList(res.data);
        // setData(res.data.datas[0]);
        setEvknWorkList(res.data.datas);

        // console.log('리스트',res.data.datas)

        if((colEvknData && colEvknData.idx == -1) || (pagination && page != pagination.current_page)){
          setColEvknData(res.data.datas[0])
        }

        setPagination(res.data.pagination)
        setTotal_cnt(res.data.pagination.total_count)
      }else{
        // console.log('api 리턴 데이터', res.data)
        setEvknWorkList(res.data.datas);
        setPagination(res.data.pagination)
        setTotal_cnt(0)
      }
      setBackdrop(false)
      // setPagination(res.data.pagination); 
      })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  // const updateInstructionDetailData = async () => {

  //   if(evkn_detail_data.topic_cd == "None" || evkn_detail_data.topic_cd == ""){
  //     alert('Instruction 주제분류 를 선택하세요.')
  //     return;
  //   }

  //   if(evkn_detail_data.answer == "None" || evkn_detail_data.answer == ""){
  //     alert('Answer 을 선택하세요.')
  //     return;
  //   }

  //   if((evkn_detail_data.instruction_sw == "None" || evkn_detail_data.instruction_sw == "") || (evkn_detail_data.instruction_ko == "None" || evkn_detail_data.instruction_ko == "")){
  //     alert('Instruction Question , 질문 은 필수입니다.')
  //     return;
  //   }

  //   if((evkn_detail_data.choice_sw_1 == "None" || evkn_detail_data.choice_sw_1 == "") 
  //     || (evkn_detail_data.choice_sw_2 == "None" || evkn_detail_data.choice_sw_2 == "")
  //     || (evkn_detail_data.choice_sw_3 == "None" || evkn_detail_data.choice_sw_3 == "")
  //     || (evkn_detail_data.choice_sw_4 == "None" || evkn_detail_data.choice_sw_4 == "")
  //     || (evkn_detail_data.choice_ko_1 == "None" || evkn_detail_data.choice_ko_1 == "")
  //     || (evkn_detail_data.choice_ko_2 == "None" || evkn_detail_data.choice_ko_2 == "")
  //     || (evkn_detail_data.choice_ko_3 == "None" || evkn_detail_data.choice_ko_3 == "")
  //     || (evkn_detail_data.choice_ko_4 == "None" || evkn_detail_data.choice_ko_4 == "")){
  //     alert('Instruction options , 선택항목 은 필수입니다.')
  //     return;
  //   }

  //   const formData = new FormData();

  //   formData.append("email", email);

  //   formData.append("prc_idx", prc_data.idx.toString());

  //   formData.append("worker", worker);

  //   formData.append("evkn_detail_data", JSON.stringify(evkn_detail_data));

  //   // console.log('evkn_detail_data', evkn_detail_data)

  //   // return ;
    
  //   await api.post("/sw-instruction-detail-update",formData)
  //   .then((res:any) => { alert("Instruction 수정 완료"); })
  //   .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  // }


  useEffect(() => {
    if(props.rowDetail != undefined){
      if(props.rowDetail.instruction_data == 'Y'){
        // getPrcDetail(props.rowDetail.idx)
        // getSwInstructionDetail(props.rowDetail.idx)
        setPageType("update")
      }else{
        // getPrcDetail(props.rowDetail.idx)
        setEvkn_detail_data(initailEvknData);
        setPageType("new")
      }
    }
    getEvknWorkList()
  }, [page, gub_cd, props.rowDetail]);

  // if(prc_data == undefined) {return <Paper sx={{width:"100%", overflow: "auto"}}><Box sx={{fontWeight:700, fontSize: "52px"}}>Loading ...</Box></Paper>}

  return (
    // (pageType == "new" ?
    <Paper sx={{width:"100%", overflow: "auto"}}>
      {backdrop && ( <SearchBackDrop message={"처리중..."}/> )}
      <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>지식 - 데이터 검수</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box display="flex">

        <Box display="flex">
          <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
            <Box sx={{width:"800px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
              <Box sx={{display:"flex", alignItems:"center"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{display:"flex", alignItems:"center", justifyContent:"left"}}>
                      <Box sx={{fontSize:"14px",fontWeight:700, width:"120px"}}>document_id</Box>
                      <TextField
                        value={search_doc_id}
                        onChange={(e) => setSearch_doc_id(e.target.value)}
                        variant="outlined"
                        size="small"
                        sx={{ width: "300px", mr: 1 ,backgroundColor: "#fff"}}
                      />
                      <Button variant="contained" onClick={search_data}>
                        조회
                      </Button>

                      {/* <Button sx={{ marginLeft: "100px"}} variant="contained" color="secondary" onClick={updateKeep}>
                        데이터 선정
                      </Button> */}
                    </Box>
                    <Box sx={{alignItems:"center", justifyContent:"center"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (CATEGORY)</Box>
                      <Select id="topic_cd" value={colEvknData.category || ""} onChange={(e) => {setColEvknData({ ...colEvknData, category: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"790px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={""}>선택하세요</MenuItem>
                        <MenuItem dense value={"101"}>한국형-역사</MenuItem>
                        <MenuItem dense value={"102"}>한국형-문화</MenuItem>
                        <MenuItem dense value={"103"}>한국형-사회</MenuItem>
                        <MenuItem dense value={"104"}>한국형-지리</MenuItem>
                        <MenuItem dense value={"105"}>한국형-언어</MenuItem>
                        <MenuItem dense value={"106"}>한국형-정치및법</MenuItem>
                        <MenuItem dense value={"201"}>글로벌-일반상식</MenuItem>
                        <MenuItem dense value={"202"}>글로벌-과학</MenuItem>
                        <MenuItem dense value={"203"}>글로벌-인문학및사회학</MenuItem>
                        <MenuItem dense value={"204"}>글로벌-공학및기술</MenuItem>
                        <MenuItem dense value={"205"}>글로벌-경제</MenuItem>
                        <MenuItem dense value={"206"}>글로벌-기타</MenuItem>
                      </Select>
                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                      <Box><textarea value={colEvknData.keyword} onChange={(e) => {setColEvknData({ ...colEvknData, keyword: e.target.value });}} spellCheck="false" style={{width:"790px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>
                    </Box>
                    <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                    <Box><textarea value={colEvknData.title} onChange={(e) => {setColEvknData({ ...colEvknData, title: e.target.value });}} spellCheck="false" style={{width:"790px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                    <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                    <Box><textarea value={colEvknData.text} onChange={(e) => {setColEvknData({ ...colEvknData, text: e.target.value });}} spellCheck="false" style={{width:"790px",minHeight:"520px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                  </Box>
                </Box>
              </Box>
            </Box>
          </Paper>
        </Box>

        {/* simpleQA */}
        {colEvknData.gub_cd === '1' &&
        <Box display="flex">
          <Box sx={{width:"100%"}}>
            <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#e4ffdc"}}>
              <Box sx={{margin:"4px"}}>
                <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                  <Box>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>SimpleQA</Box>
                    <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                    <Box><textarea spellCheck="false" value={colEvknData.question || ""} onChange={(e) => {setColEvknData({ ...colEvknData, question: e.target.value });}} style={{border:"4px solid #000", width:"620px",minHeight:"140px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"420px"}}>
                <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea spellCheck="false" value={colEvknData.answer || ""} onChange={(e) => {setColEvknData({ ...colEvknData, answer: e.target.value });}} style={{border:"4px solid #000", width:"620px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"420px"}}>
                <Box sx={{margin:"8px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer (gpt-4o)</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea readOnly={true} spellCheck="false" value={colEvknData.answer_gpt || ""} style={{width:"620px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"420px"}}>
                <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer (gemini)</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea readOnly={true} spellCheck="false" value={colEvknData.answer_gemini || ""} style={{width:"620px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"100%", marginTop: "16px"}}>
                <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#fff9c1"}}>
                  <Box sx={{margin:"4px 4px 4px 4px"}}>
                    <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px", width:"420px"}}>
                      <Box sx={{fontSize:"24px", fontWeight:700, textAlign:"center", margin:"2px"}}>추론경로(CoT)</Box>
                        {/* <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box> */}
                        {/* <Box><textarea spellCheck="false" value={evkn_detail_data.instruction_sw || ""} onChange={(e) => {setEvkn_detail_data({ ...evkn_detail_data, instruction_sw: e.target.value });}} style={{width:"610px",minHeight:"120px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box> */}
                      </Box>
                      <Box><Button sx={{backgroundColor:"#9169ff"}} variant="contained" onClick={handleAdd}>항목 추가</Button></Box>
                    </Box>
                  </Box>
  
                  <Box sx={{width:"750px",margin:"4px", height:"200px", overflow:"auto"}}>
                    <Box sx={{margin:"4px 0px 4px 2px", color:"#4664b4", fontWeight:700}}>Reason Path ({reason_path && reason_path.length})</Box>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                        {reason_path && reason_path.map((item:any, index:any) => 
                          <Box key={"Box"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                            <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px" }}>{index + 1}.</Box>
                            <textarea key={index} spellCheck="false" value={item || ""}  onChange={(e) => reason_path_change(index, e.target.value)} style={{width:"640px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  />
                            <DangerousRoundedIcon sx={{marginLeft:"8px"}} onClick={() => handleRemove(index)}>✕</DangerousRoundedIcon>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                  
                  <Box display="flex">
                    <Box sx={{display:"flex", marginTop:"16px"}}>
                      <Box sx={{display:"flex",marginLeft:"4px"}}>
                        <Box sx={{margin:"8px 12px 0px 4px",width:"32px", fontWeight:700}}>비고</Box>
                        <Box><textarea value={(colEvknData.des === "None" ? "" : colEvknData.des) || ""} onChange={(e) => {setColEvknData({ ...colEvknData, des: e.target.value });}} style={{width:"360px",minHeight:"40px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                      </Box>
                    </Box>
                    {worker !== 'EVAL008' &&
                      <>
                        <Box sx={{width:"100%", marginTop: "8px"}}>
                          <Box display="flex" justifyContent="center">
                            <Button variant="contained" color="primary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                              onClick={() => {
                                updateColEvknData('Y');
                              }}
                            >
                              O (선정)
                            </Button>
                          </Box>
                        </Box>
                        <Box sx={{width:"100%", marginTop: "8px"}}>
                          <Box display="flex" justifyContent="center">
                            <Button variant="contained" color="secondary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                              onClick={() => {
                                updateColEvknData('P');
                              }}
                            >
                              X
                            </Button>
                          </Box>
                        </Box>
                      </>
                    }
                  </Box>
                  
                </Paper>
              </Box>
              
            </Paper>
          </Box>
        </Box>
        }
        {/* simpleQA */}

        {/* HELLASWAG */}
        {colEvknData.gub_cd === '3' &&
        <Box display="flex">
          <Box sx={{width:"100%"}}>
            <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#ffdcf5"}}>
              <Box display="flex" justifyContent="center">
                <Box sx={{fontSize:"20px", fontWeight:700, textAlign:"center", margin:"2px"}}>HELLASWAG</Box>
                <Button variant="contained" size="small" sx={{marginLeft:"32px",fontWeight:700, backgroundColor:"#e79055"}} onClick={() => setOpenJsonDialog(true)}>
                  OPEN JSON
                </Button>
                
              </Box>
              {openJsonDialog ? <EvalJsonDialog className="json-dialog-content" data={colEvknData.json_data} setOpenJsonDialog={setOpenJsonDialog} />:<></>}
              <Box display="flex">
                <Box>
                  <Box sx={{margin:"4px"}}>
                    <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                      <Box>
                        <Box sx={{margin:"0px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question (난이도 : <b style={{fontSize:"14px", fontWeight:700, textAlign:"center", margin:"2px", color:(colEvknData.difficulty === "H" ? "red":(colEvknData.difficulty === "M" ? "#d7c200": "#00db45")) }}>{(colEvknData.difficulty === "H" ? "High":(colEvknData.difficulty === "M" ? "Medium": "Low"))}</b>)</Box>
                        <Box><textarea spellCheck="false" value={colEvknData.question || ""} onChange={(e) => {setColEvknData({ ...colEvknData, question: e.target.value });}} style={{border:"4px solid #000", width:"380px",minHeight:"240px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                      </Box>
                    </Box>
                  </Box>

                  {/* <Box sx={{width:"420px"}}>
                    <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer</Box>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                        <Box><textarea spellCheck="false" value={colEvknData.answer || ""} onChange={(e) => {setColEvknData({ ...colEvknData, answer: e.target.value });}} style={{border:"4px solid #000", width:"340px",minHeight:"16px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                      </Box>
                    </Box>
                  </Box> */}

                </Box>
                <Box>
                  <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Options</Box>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                      {options && options.map((item:any, index:any) => 
                        <Box key={"Box_Options"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                          <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px", color:(colEvknData.json_data.answer_index === index ? "red" : "#000") }}>{String.fromCharCode(65 + index)}.</Box>
                          <textarea key={index} readOnly={colEvknData.json_data.answer_index === index} spellCheck="false" value={item || ""} onChange={colEvknData.json_data.answer_index !== index ? (e:any) => options_change(index, e.target.value) : undefined} style={{width:"440px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", backgroundColor:(colEvknData.json_data.answer_index === index ? "#f0ffea" : "#fff"), fontFamily: "Noto Sans KR"}}  />
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>

              {/* <Box display="flex">
                <Box sx={{width:"360px"}}>
                  <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer (gpt-4o)</Box>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                      <Box><textarea readOnly={true} spellCheck="false" value={colEvknData.answer_gpt || ""} style={{width:"340px",minHeight:"16px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{width:"360px"}}>
                  <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer (gemini)</Box>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                      <Box><textarea readOnly={true} spellCheck="false" value={colEvknData.answer_gemini || ""} style={{width:"340px",minHeight:"16px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box> */}

              <Box sx={{width:"100%", marginTop: "16px"}}>
                <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#fff9c1"}}>
                  <Box sx={{margin:"4px 4px 4px 4px"}}>
                    <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px", width:"420px"}}>
                      <Box sx={{fontSize:"24px", fontWeight:700, textAlign:"center", margin:"2px"}}>추론경로(CoT)</Box>
                        {/* <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box> */}
                        {/* <Box><textarea spellCheck="false" value={evkn_detail_data.instruction_sw || ""} onChange={(e) => {setEvkn_detail_data({ ...evkn_detail_data, instruction_sw: e.target.value });}} style={{width:"610px",minHeight:"120px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box> */}
                      </Box>
                      <Box><Button sx={{backgroundColor:"#9169ff"}} variant="contained" onClick={handleAdd}>항목 추가</Button></Box>
                    </Box>
                  </Box>
  
                  <Box sx={{width:"840px",margin:"4px", height:"320px", overflow:"auto"}}>
                    <Box sx={{margin:"4px 0px 4px 2px", color:"#4664b4", fontWeight:700}}>Reason Path ({reason_path && reason_path.length})</Box>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                        {reason_path && reason_path.map((item:any, index:any) => 
                          <Box key={"Box"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                            <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px" }}>{index + 1}.</Box>
                            <textarea key={index} spellCheck="false" value={item || ""}  onChange={(e) => reason_path_change(index, e.target.value)} style={{width:"720px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  />
                            <DangerousRoundedIcon sx={{marginLeft:"8px"}} onClick={() => handleRemove(index)}>✕</DangerousRoundedIcon>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                  
                  <Box display="flex">
                    <Box sx={{display:"flex", marginTop:"16px"}}>
                      <Box sx={{display:"flex",marginLeft:"4px"}}>
                        <Box sx={{margin:"8px 12px 0px 4px",width:"32px", fontWeight:700}}>비고</Box>
                        <Box><textarea value={(colEvknData.des === "None" ? "" : colEvknData.des) || ""} onChange={(e) => {setColEvknData({ ...colEvknData, des: e.target.value });}} style={{width:"360px",minHeight:"40px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                      </Box>
                    </Box>
                    {worker !== 'EVAL008' &&
                    <>
                      <Box sx={{width:"100%", marginTop: "8px"}}>
                        <Box display="flex" justifyContent="center">
                          <Button variant="contained" color="primary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                            onClick={() => {
                              updateColEvknData('Y');
                            }}
                          >
                            O (선정)
                          </Button>
                        </Box>
                      </Box>
                      <Box sx={{width:"100%", marginTop: "8px"}}>
                        <Box display="flex" justifyContent="center">
                          <Button variant="contained" color="secondary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                            onClick={() => {
                              updateColEvknData('P');
                            }}
                          >
                            X
                          </Button>
                        </Box>
                      </Box>
                    </>
                    }

                  </Box>
                  
                </Paper>
              </Box>
              
            </Paper>
          </Box>
        </Box>
        }
        {/* HELLASWAG */}

        {/* MMLU */}
        {colEvknData.gub_cd === '4' &&
        <Box display="flex">
          <Box sx={{width:"100%"}}>
            <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#e9dcff"}}>
              <Box display="flex" justifyContent="center">
                <Box sx={{fontSize:"20px", fontWeight:700, textAlign:"center", margin:"2px"}}>MMLU</Box>
                <Button variant="contained" size="small" sx={{marginLeft:"32px",fontWeight:700, backgroundColor:"#e79055"}} onClick={() => setOpenJsonDialog(true)}>
                  OPEN JSON
                </Button>
              </Box>
              {openJsonDialog ? <EvalJsonDialog className="json-dialog-content" data={colEvknData} setOpenJsonDialog={setOpenJsonDialog} />:<></>}
              <Box display="flex">
                <Box>
                  <Box sx={{margin:"4px"}}>
                    <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                      <Box>
                        <Box sx={{margin:"0px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                        <Box><textarea spellCheck="false" value={colEvknData.question || ""} onChange={(e) => {setColEvknData({ ...colEvknData, question: e.target.value });}} style={{border:"4px solid #000", width:"440px",minHeight:"240px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                      </Box>
                    </Box>
                  </Box>

                  <Box sx={{width:"420px"}}>
                    <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer</Box>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                        <Box><textarea spellCheck="false" value={colEvknData.answer || ""} onChange={(e) => {setColEvknData({ ...colEvknData, answer: e.target.value });}} style={{border:"4px solid #000", width:"400px",minHeight:"16px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                      </Box>
                    </Box>
                  </Box>

                </Box>
                <Box>
                  <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Options</Box>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                      {options && options.map((item:any, index:any) => 
                        <Box key={"Box_Options"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                          <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px", color:(colEvknData.answer === String.fromCharCode(65 + index) ? "red" : "#000") }}>{String.fromCharCode(65 + index)}.</Box>
                          <textarea key={index} readOnly={colEvknData.answer === String.fromCharCode(65 + index)} spellCheck="false" value={item || ""} onChange={colEvknData.answer !== String.fromCharCode(65 + index) ? (e:any) => options_change(index, e.target.value) : undefined} style={{width:"280px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", backgroundColor:(colEvknData.answer === String.fromCharCode(65 + index) ? "#f0ffea" : "#fff"), fontFamily: "Noto Sans KR"}}  />
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box display="flex">
                <Box sx={{width:"360px"}}>
                  <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer (gpt-4o)</Box>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                      <Box><textarea readOnly={true} spellCheck="false" value={colEvknData.answer_gpt || ""} style={{width:"340px",minHeight:"16px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{width:"360px"}}>
                  <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer (gemini)</Box>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                      <Box><textarea readOnly={true} spellCheck="false" value={colEvknData.answer_gemini || ""} style={{width:"340px",minHeight:"16px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR", backgroundColor:(evkn_detail_data.answer === "A" ? "#f0ffea" : "#fff")}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"100%", marginTop: "16px"}}>
                <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#fff9c1"}}>
                  <Box sx={{margin:"4px 4px 4px 4px"}}>
                    <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px", width:"420px"}}>
                      <Box sx={{fontSize:"24px", fontWeight:700, textAlign:"center", margin:"2px"}}>추론경로(CoT)</Box>
                        {/* <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box> */}
                        {/* <Box><textarea spellCheck="false" value={evkn_detail_data.instruction_sw || ""} onChange={(e) => {setEvkn_detail_data({ ...evkn_detail_data, instruction_sw: e.target.value });}} style={{width:"610px",minHeight:"120px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box> */}
                      </Box>
                      <Box><Button sx={{backgroundColor:"#9169ff"}} variant="contained" onClick={handleAdd}>항목 추가</Button></Box>
                    </Box>
                  </Box>
  
                  <Box sx={{width:"750px",margin:"4px", height:"200px", overflow:"auto"}}>
                    <Box sx={{margin:"4px 0px 4px 2px", color:"#4664b4", fontWeight:700}}>Reason Path ({reason_path && reason_path.length})</Box>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                        {reason_path && reason_path.map((item:any, index:any) => 
                          <Box key={"Box"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                            <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px" }}>{index + 1}.</Box>
                            <textarea key={index} spellCheck="false" value={item || ""}  onChange={(e) => reason_path_change(index, e.target.value)} style={{width:"640px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  />
                            <DangerousRoundedIcon sx={{marginLeft:"8px"}} onClick={() => handleRemove(index)}>✕</DangerousRoundedIcon>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                  
                  <Box display="flex">
                    <Box sx={{display:"flex", marginTop:"16px"}}>
                      <Box sx={{display:"flex",marginLeft:"4px"}}>
                        <Box sx={{margin:"8px 12px 0px 4px",width:"32px", fontWeight:700}}>비고</Box>
                        <Box><textarea value={(colEvknData.des === "None" ? "" : colEvknData.des) || ""} onChange={(e) => {setColEvknData({ ...colEvknData, des: e.target.value });}} style={{width:"360px",minHeight:"40px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                      </Box>
                    </Box>
                    
                    {worker !== 'EVAL008' &&
                    <>
                      <Box sx={{width:"100%", marginTop: "8px"}}>
                        <Box display="flex" justifyContent="center">
                          <Button variant="contained" color="primary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                            onClick={() => {
                              updateColEvknData('Y');
                            }}
                          >
                            O (선정)
                          </Button>
                        </Box>
                      </Box>
                      <Box sx={{width:"100%", marginTop: "8px"}}>
                        <Box display="flex" justifyContent="center">
                          <Button variant="contained" color="secondary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                            onClick={() => {
                              updateColEvknData('P');
                            }}
                          >
                            X
                          </Button>
                        </Box>
                      </Box>
                      </>
                    }
                  </Box>
                  
                </Paper>
              </Box>
              
            </Paper>
          </Box>
        </Box>
        }
        {/* MMLU */}

        {/* 작업 리스트 */}
        <Box>
        {/* Task 단위 화면 */}
        <Box display="flex" justifyContent="center" >
          <Box sx={{padding:"4px 8px 8px 8px", width:"368px"}}>
            <Box display="flex">
              <Box><img style={{width:"24px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/ko_flag.jpg'} /></Box>
              <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>작업목록</Box>
              {worker === 'EVAL008' && 
              <>
                <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>TASK</Box> 
                <Select id="gub_cd" value={gub_cd || "모두"} onChange={(e) => {setGub_cd(e.target.value );}} sx={{backgroundColor: "#fff",color:"green",width:"180px", height: "28px", marginLeft: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                  <MenuItem dense value={"모두"}>모두</MenuItem>
                  <MenuItem dense value={"1"}>SIMPLE</MenuItem>
                  <MenuItem dense value={"3"}>HELLASWAG</MenuItem>
                  <MenuItem dense value={"4"}>MMLU</MenuItem>
                </Select>
              </>}
            </Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
              <Table size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>검수</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>유형</Box></TableCell>
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>CONCEPT</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>USE_CHECK</Box></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                {(evknWorkList != undefined && evknWorkList.length > 0) ? evknWorkList.map((row:any, index:number) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(colEvknData != undefined && row.idx === colEvknData.idx ? "#dbdbef": "#fff")}}
                    onClick={()=> {setColEvknData(row); setReason_path(JSON.parse(row.reason_path)); if(row.gub_cd !== '1') setOptions(JSON.parse(row.options));}}
                  >
                    <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                    {/* <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.isp1_yn === "N" ? "2px solid red" : (row.isp1_yn === "0" ? "2px solid #bbb" : (row.isp1_yn === "Y" ? "2px solid #27cc2f" : "#000"))), color:"#000" }}>
                        {(row.isp1_yn === "Y" ? "적합" : (row.isp1_yn === "N" ? "부적합" : (row.isp1_yn === "0" ? "미작업":"-")))}
                      </Box>
                    </TableCell> */}
                    {/* <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.instruction_data === "Y" ? "2px solid #27cc2f" : "2px solid #bbb"), color:"#000" }}>
                        {(row.instruction_data === "Y" ? "작성" : "미작성")}
                      </Box>
                    </TableCell> */}
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.job_yn === "Y" ? "2px solid #27cc2f" : (row.job_yn === "P" ? "2px solid #7427cc" : "#000")), color:"#000" }}>
                        {(row.job_yn === "Y" ? "완료" : (row.job_yn === "P" ? "X" : "미작업"))}
                      </Box>
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"48px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px", color:"#000" }}>
                        {/* {row.gub_cd} */}
                        {(row.gub_cd === "1" ? "simple" : (row.gub_cd === "3" ? "hellaswag" : "mmlu"))}
                      </Box>
                    </TableCell>
                    {/* <TableCell align="left">{row.concept_en}</TableCell> */}
                    {/* <TableCell align="left">
                      <Box sx={{width:"58px",fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                          border: (row.use_check === "F" ? "2px solid red" : (row.use_check === "T" ? "2px solid #498ad5" : (row.use_check === "C" ? "2px solid #27cc2f" : "#bbb"))), color:"#000" }}>
                        {(row.use_check === "T" ? "사용가능" : (row.use_check === "F" ? "사용불가" : (row.use_check === "C" ? "내용수정":"미분류")))}
                      </Box>
                    </TableCell> */}
                  </TableRow>
                  )):<TableRow><TableCell colSpan={3} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{marginTop:"12px"}}>
              {pagination !== undefined ? (
                  <>
                  <CustomPagination pagination={pagination} goPage={goPage} />
                  <Box display="flex">
                  <TextField size="small" id="worker" value={c_page} onChange={(e)=>setC_page(e.target.value)} 
                    sx={{width:"60px",height: "23px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} 
                    InputProps={{
                      style: {width: "60px", height:"23px", fontSize:"12px"},
                      inputProps: { 
                        spellCheck: "false" // spellcheck를 false로 설정
                      },
                    }}
                    />
                    <Button variant="contained" sx={{marginLeft:"8px",minWidth: "58px", height:"30px", fontSize:"12px"}} onClick={()=>setPage(Number(c_page))}>
                      이동
                    </Button>
                  </Box>
                  </>
              ) : ""}
            </Box>
          </Box>
          
          
        </Box>
      </Box>
            
        {/* : ""} */}
        
      </Box>

    </Paper>
  );
  
  
};

export default EvknHellaSwagPage;
